/**
 * A tiny stack of open overlay layers (modals, drawers, popovers). Only the top-most layer
 * responds to Escape and traps focus, so nested overlays close one at a time.
 */
const stack: symbol[] = [];

export function pushLayer(layer: symbol): () => void {
  stack.push(layer);
  return () => {
    const index = stack.lastIndexOf(layer);
    if (index >= 0) stack.splice(index, 1);
  };
}

export function isTopLayer(layer: symbol): boolean {
  return stack[stack.length - 1] === layer;
}

let scrollLocks = 0;
let previousOverflow = '';
let previousPaddingRight = '';

/** Locks body scrolling (ref-counted so nested overlays behave). Returns the unlock function. */
export function lockBodyScroll(): () => void {
  const body = document.body;
  if (scrollLocks === 0) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    previousOverflow = body.style.overflow;
    previousPaddingRight = body.style.paddingRight;
    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
  }
  scrollLocks += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    scrollLocks -= 1;
    if (scrollLocks === 0) {
      body.style.overflow = previousOverflow;
      body.style.paddingRight = previousPaddingRight;
    }
  };
}
